<template>
  <nav class="navbar is-hidden-mobile" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" :to="{ name: 'dashboard' }">
        <img alt="Car Trackr Logo" src="../assets/logo.svg" width="28" height="28">
        Car Trackr
      </router-link>
    </div>

    <div class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <button class="button is-outlined is-danger" @click="logout">
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { onLogout } from '../vue-apollo';

export default {
  name: 'Header',
  methods: {
    logout() {
      onLogout(this.$apollo.getClient());
      this.$router.push({ name: 'home' });
      this.$toasted.success('Signed Out!');
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  padding: 0 .75rem;
  border-bottom: 1px solid black;

  .navbar-item {
    img {
      margin-right: .75rem;
    }
  }
}
</style>
